import React from 'react';
import './HamburgerButton.scss';
import Hamburger from '../../UI/Icons/Hamburger';

const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;

/**
 * Render hamburger menu shown on mobile/tablet devices to show/hide mobile menu when clicked
 * @param {Function} toggleMenu - Reference to toggleMenu function in Header.js component which opens/closes the me
 * @param drawer
 * @returns {JSX.Element}
 * @constructor
 */
const HamburgerButton = ({ toggleMenu, drawer }) => (
  <button
    className="c-hamburger-btn"
    onClick={() => {
      toggleMenu();
      disableBodyScroll(drawer);
    }}
  >
    <Hamburger />
  </button>
);

export default HamburgerButton;
